import {defineStore} from 'pinia'
// import {client} from "@/libraries/http";
import store from "store";

const useAuthnStore = defineStore('user', {
    state: () => ({
        authorization: null,
        login: false,
        title: null,
        user: {
            loginType: null,
            userName: null,
            userPhone: null
        },
        leoParams: {
            phoneNumber: null,
            username: null,
            projectId: null,
            tenantCode: null,
            tenantName: null,
            brand: null,
            building_name: null,
            company_code: null,
            company_name: null,
            appKey: null,
            invalidTime: null,
            sign: null
        },
        latestLoginType: store.get('latestLoginType'),
        ...store.get('authn')
    }),
    getters: {
        /**
         * 是否是租户员工
         *
         * @param state
         * @returns {boolean}
         */
        isTenant(state) {
            return state.user.loginType === 'TENANT'
        },
        /**
         * 是否是施工人员
         *
         * @param state
         * @returns {boolean}
         */
        isConstruction(state) {
            return state.user.loginType === 'CONSTRUCTION'
        },
        /**
         * 是否是施工人员管理者
         *
         * @param state
         * @returns {boolean}
         */
        isConstructionManager(state) {
            return state.user.loginType === 'CONSTRUCTION_MANAGER'
        },
        isLatestLoginTenant(state) {
            return state.latestLoginType === 'TENANT'
        },
        isLatestLoginManagement(state) {
            return state.latestLoginType === 'MANAGEMENT'
        },
        getUserPhone(state) {
            return state.user.userPhone
        },
        getTitle(state){
            return state.title
        }
    },
    actions: {
        token(authn) {
            this.authorization = `Bearer ${authn.token}`;
            this.login = true;
            this.user = authn.user;
            this.leoParams = authn.leoParams;
            this.latestLoginType = authn.user?.loginType;
            this.title = authn.title;
            store.set('latestLoginType', this.latestLoginType)
            store.set('authn', {
                authorization: this.authorization,
                login: this.login,
                user: this.user,
                leoParams: this.leoParams
            });
            console.log("store")
            console.log(store.get('authn'))
            store.remove('project');
        },
        logout() {
            this.authorization = null;
            this.login = false;
            this.user = null;
            this.leoParams = null;
            this.title = null;
            store.remove('authn');
            store.remove('project');
        }
        // async login(authorization) {
        //     try {
        //         // this.userData = await client.post({login, password})
        //         this.authorization = authorization;
        //         // showTooltip(`Welcome back ${this.userData.name}!`)
        //     } catch (error) {
        //         // showTooltip(error)
        //         // let the form component display the error
        //         return error
        //     }
        // },
    },
})

export default useAuthnStore;
